import * as ROUTES from './routes';
import * as MODEL_TYPES from './model-types';
import * as SITE_HEADER from './site-header';
import * as STATIC_STATISTICS from './static-statistics';

export default {
  ...ROUTES,
  ...MODEL_TYPES,
  ...SITE_HEADER,
  ...STATIC_STATISTICS,
};
